/*eslint no-console: 0*/

import React from 'react';
import PropTypes from 'prop-types';
import Grid from '../fw/Grid.react';
import {FormattedMessage, IntlShape} from 'react-intl';

import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';

interface DataSetListProps {
    dataSets: object;
    sourceGroupDefs: object;
    title?: any;
}

export default class DataSetList extends React.Component<DataSetListProps> {

    static propTypes = {
        dataSets: PropTypes.object.isRequired,
        sourceGroupDefs: PropTypes.object.isRequired,
		title: PropTypes.any,
    };

    constructor(props) {
        super(props);

        this.state = {
            filterEmpty: true
        };
    }

	// eslint-disable-next-line max-params
    renderLine = (content, column, item, url, columnMapping) => {
        if (item && item.storeInfo && item.storeInfo.hasAnyData) {
            return <strong>{content}</strong>;
        } else {
            return <i>{content}</i>;
        }
    };

    render() {
        let dataSets = this.props.dataSets.edges.map(({node}) => node);
        let showedSomeGroups = false;

        return (
            <div className="DataSetList">
                {
                    this.props.sourceGroupDefs.edges.map(({node}) => {
                        let myDataSets = dataSets.filter((dataSet) => dataSet['sourceDef']['sourceGroupDef_id'] === node['realId'] && (!this.state.filterEmpty || dataSet['storeInfo'] && dataSet['storeInfo']['hasAnyData']));
                        /* don't show empty groups */
                        if (myDataSets.length === 0) {
                            return null;
                        }
                        dataSets = dataSets.filter((dataSet) => dataSet['sourceDef']['sourceGroupDef_id'] !== node['realId']);
                        showedSomeGroups = true;
                        return (
                            <div key={node['realId']}>
                                <h2>{node.name}</h2>
                                {<Grid
                                    columns={['sourceDef.name']}
                                    list={myDataSets}
                                    metadata={types['dataSets']}
                                    noTitles
                                    render={this.renderLine}
                                    urlMapping={urlMapping}
                                />}

                            </div>
                        );
                    })
                }
                {dataSets.filter((node) => (!this.state.filterEmpty || node['storeInfo'] && node['storeInfo']['hasAnyData'])).length > 0 ?
                    <div>
						{this.props.title ? (<h4>{this.props.title}</h4>) : null}
                        {showedSomeGroups ? <h2><FormattedMessage defaultMessage="Others" id="channelDef.otherSourceDef" /></h2> : null}
                        <Grid
                            columns={['sourceDef.name']}
                            list={dataSets.filter((node) => (!this.state.filterEmpty || node['storeInfo'] && node['storeInfo']['hasAnyData']))}
                            metadata={types['dataSets']}
                            noTitles
                            render={this.renderLine}
                            urlMapping={urlMapping}
                        />
                    </div>
                    : null}
            </div>
        );
    }
}
